import {
  DispatchTrip,
  DispatchTripRead,
  RunBambiRunReassignedTrip,
  RunBambiRunTrip,
} from 'src/common/external/bambi-api/bambiApi';

export const isDispatchTrip = (
  trip: DispatchTrip | RunBambiRunTrip | RunBambiRunReassignedTrip
): trip is DispatchTripRead => {
  return 'timing' in trip;
};
